import BookingForReview from "../Booking/Report/BookingForReview";
import * as types from "./ActionType";

const initialState = {
	Token: null,
	Profile: null,
	Place: [],
	PlaceImage: [],
	PlaceVideo: [],
	PlaceReels: [],
	onePlace: null,
	PlaceOffSetting: [],
	PlaceOnSetting: [],
	PackageCategory: [],
	onePackageCategory: null,
	Package: [],
	onePackage: null,
	BookingList: [],
	PackageBookingList: [],
	oneBooking: null,
	bookingPayment: null,
	Team: [],
	oneTeam: null,
	TeamAttendance: [],
	oneTeamAttendance: null,
	BankAccount: [],
	oneBankAccount: null,
	CreditCard: [],
	oneCreditCard: null,
	DebitCategory: [],
	oneDebitCategory: null,
	CreditCategory: [],
	oneCreditCategory: null,
	DebitNote: [],
	oneDebitNote: null,
	CreditNote: [],
	oneCreditNote: null,
	Sales: [],
	Purchase: [],
	oneSiteSetting: null,
	oneHotelSetting: null,
	HomeBanner: [],
	oneHomeBanner: null,
	HomePlace: [],
	oneHomePlace: null,
	PhoneNumber: [],
	onePhoneNumber: null,
	BankAccess: [],
	DashboardData: null,
	DashboardOtherData: null,
	AccessKeys: null,
	BankTransfer: [],
	NumberAccess: [],
	Quotation: [],
	oneQuotation: null,
	Countries: [],
	States: [],
	Visitor: [],
	TeamBankReport: [],
	StaffSalesReport: [],
	StaffSalesData: null,
	PackageImage: [],
	PackageVideo: [],
	PackageReels: [],
	TeamSalaryReport: [],
	Enquiry: [],
	oneEnquiry: null,
	PaymentHistory: null,
	DailyLedger: null,
	PlaceBookingOffSetting: [],
	homeNote: null,
	PlaceKeys: [],
	Faq: [],
	oneFaq: null,
	warningMessage: null,
	AvailableTicket: [],
	notificationCount: null,
	AllNotification: [],
	AllHotel: [],
	oneHotel: null,
	CrDrTotal: null,
	CurrentBalanceTotal: null,
	Testimonial: [],
	oneTestimonial: null,
	SalesReport: [],
	SalesReportExport: [],
	SalesReportTotal: null,
	PurchaseReport: [],
	PurchaseReportExport: [],
	PurchaseReportTotal: null,
	CommissionReport: [],
	CommissionReportExport: [],
	CommissionReportTotal: null,
	CancelReport: [],
	CancelReportExport: [],
	CancelReportTotal: null,
	AttractionReport: [],
	GstReport: [],
	GstReportExport: [],
	GstReportTotal: null,
	BookingForReview: [],
	BlogCategory: [],
	oneBlogCategory: null,
	Blog: [],
	oneBlog: null,
	BlogComment: [],
	StaffBankDetailData: null,
	DailySettlement: [],
	oneDailySettlement: null,
	AccountMainGroup: [],
	AccountSubGroup: [],
	AccountLedger: [],
	TallyBalanceSheet: null,
	TallyProfitLoss: null,
	AutoAccountEntrySetting: [],
	OptionalAttraction: [],
	oneOptionalAttraction: null,
	Sitemap: [],
	oneSitemap: null,
};

const userReducers = (state = initialState, action) => {
	const { type, payload } = action;

	const updateState = (key) => ({
		...state,
		[key]: state[key].map((item) =>
			item._id === payload[`${key}Id`]
				? { ...item, ...payload[`Updated${key}`] }
				: item
		),
	});

	const deleteFromState = (key) => ({
		...state,
		[key]: state[key].filter((item) => item._id !== payload[`${key}Id`]),
	});

	// const deleteMultipleFromState = (key) => ({
	// 	...state,
	// 	[key]: state[key].filter(
	// 		(item) => !payload[`${key}Ids`].includes(item._id)
	// 	),
	// });

	switch (type) {
		// Add cases for Login actions
		case types.SIGN_IN:
			return { ...state, Token: payload };

		case types.GET_PROFILE:
			return { ...state, Profile: payload };

		// Add cases for Place actions
		case types.GET_ALL_PLACE:
			return { ...state, Place: payload, loading: false };
		case types.GET_ALL_TRANSACTION_PLACE:
			return { ...state, TransactionPlace: payload, loading: false };
		case types.GET_ONE_PLACE:
			return { ...state, onePlace: payload, loading: false };
		case types.CLEAR_ONE_PLACE:
			return { ...state, onePlace: null, loading: false };
		case types.SET_PLACE:
			return { ...state, Place: [...state.Place, payload] };
		case types.UPDATE_PLACE:
			return updateState("Place");
		case types.DELETE_PLACE:
			return deleteFromState("Place");

		case types.GET_ALL_PLACE_IMAGE:
			return { ...state, PlaceImage: payload, loading: false };
		case types.SET_PLACE_IMAGE:
			return { ...state, PlaceImage: [...state.PlaceImage, payload] };
		case types.DELETE_PLACE_IMAGE:
			return deleteFromState("PlaceImage");

		case types.GET_ALL_PLACE_VIDEO:
			return { ...state, PlaceVideo: payload, loading: false };
		case types.SET_PLACE_VIDEO:
			return { ...state, PlaceVideo: [...state.PlaceVideo, payload] };
		case types.DELETE_PLACE_VIDEO:
			return deleteFromState("PlaceVideo");

		case types.GET_ALL_PLACE_REELS:
			return { ...state, PlaceReels: payload, loading: false };
		case types.SET_PLACE_REELS:
			return { ...state, PlaceReels: [...state.PlaceReels, payload] };
		case types.DELETE_PLACE_REELS:
			return deleteFromState("PlaceReels");

		case types.GET_ALL_PLACE_ON_SETTING:
			return { ...state, PlaceOnSetting: payload, loading: false };
		case types.SET_ALL_PLACE_ON_SETTING:
			return { ...state, PlaceOnSetting: [...state.PlaceOnSetting, payload] };
		case types.DELETE_PLACE_ON_SETTING:
			return deleteFromState("PlaceOnSetting");

		case types.GET_ALL_PLACE_OFF_SETTING:
			return { ...state, PlaceOffSetting: payload, loading: false };
		case types.SET_ALL_PLACE_OFF_SETTING:
			return { ...state, PlaceOffSetting: [...state.PlaceOffSetting, payload] };
		case types.DELETE_PLACE_OFF_SETTING:
			return deleteFromState("PlaceOffSetting");

		case types.GET_ALL_PACKAGE_CATEGORY:
			return { ...state, PackageCategory: payload, loading: false };
		case types.GET_ONE_PACKAGE_CATEGORY:
			return { ...state, onePackageCategory: payload, loading: false };
		case types.CLEAR_PACKAGE_CATEGORY:
			return { ...state, onePackageCategory: null, loading: false };
		case types.SET_PACKAGE_CATEGORY:
			return { ...state, PackageCategory: [...state.PackageCategory, payload] };
		case types.UPDATE_PACKAGE_CATEGORY:
			return updateState("PackageCategory");
		case types.DELETE_PACKAGE_CATEGORY:
			return deleteFromState("PackageCategory");

		case types.GET_ALL_PACKAGE:
			return { ...state, Package: payload, loading: false };
		case types.GET_ONE_PACKAGE:
			return { ...state, onePackage: payload, loading: false };
		case types.CLEAR_ONE_PACKAGE:
			return { ...state, onePackage: null, loading: false };
		case types.SET_PACKAGE:
			return { ...state, Package: [...state.Package, payload] };
		case types.UPDATE_PACKAGE:
			return updateState("Package");
		case types.DELETE_PACKAGE:
			return deleteFromState("Package");

		// case types.GET_ALL_PLACE_BOOKING_ON_SETTING:
		// 	return { ...state, PlaceBookingOnSetting: payload, loading: false };
		// case types.SET_ALL_PLACE_BOOKING_ON_SETTING:
		// 	return { ...state, PlaceOnSetting: [...state.PlaceOnSetting, payload] };
		// case types.DELETE_PLACE_BOOKING_ON_SETTING:
		// 	return deleteFromState("PlaceOnSetting");

		case types.GET_ALL_BOOKINGS:
			return { ...state, BookingList: payload, loading: false };
		case types.GET_ONE_BOOKING:
			return { ...state, oneBooking: payload, loading: false };
		case types.CLEAR_ONE_BOOKING:
			return { ...state, oneBooking: null, loading: false };
		case types.GET_BOOKING_PAYMENT:
			return { ...state, bookingPayment: payload, loading: false };
		case types.UPDATE_BOOKING:
			return updateState("BookingList");
		case types.GET_ATTRACTION_BOOKING_COUNT:
			return { ...state, attractionBookingCount: payload, loading: false };
		case types.MOVE_BOOKING:
			return deleteFromState("BookingList");

		case types.GET_ALL_PACKAGE_BOOKINGS:
			return { ...state, PackageBookingList: payload, loading: false };
		case types.GET_PACKAGE_BOOKING_COUNT:
			return { ...state, packageBookingCount: payload, loading: false };

		case types.GET_ALL_TEAM:
			return { ...state, Team: payload, loading: false };
		case types.GET_ONE_TEAM:
			return { ...state, oneTeam: payload, loading: false };
		case types.CLEAR_ONE_TEAM:
			return { ...state, oneTeam: null, loading: false };
		case types.SET_TEAM:
			return { ...state, Team: [...state.Team, payload] };
		case types.UPDATE_TEAM:
			return updateState("Team");
		case types.DELETE_TEAM:
			return deleteFromState("Team");
		case types.GET_TEAM_ATTENDANCE:
			return { ...state, TeamAttendance: payload, loading: false };
		case types.SET_TEAM_ATTENDANCE:
			return { ...state, TeamAttendance: [...state.TeamAttendance, payload] };
		case types.UPDATE_TEAM_ATTENDANCE:
			return updateState("TeamAttendance");
		case types.GET_ONE_TEAM_ATTENDANCE:
			return { ...state, oneTeamAttendance: payload, loading: false };
		case types.CLEAR_ONE_TEAM_ATTENDANCE:
			return { ...state, oneTeamAttendance: null, loading: false };

		case types.GET_ALL_BANK_ACCOUNT:
			return { ...state, BankAccount: payload, loading: false };
		case types.GET_ONE_BANK_ACCOUNT:
			return { ...state, oneBankAccount: payload, loading: false };
		case types.CLEAR_ONE_BANK_ACCOUNT:
			return { ...state, oneBankAccount: null, loading: false };
		case types.SET_BANK_ACCOUNT:
			return { ...state, BankAccount: [...state.BankAccount, payload] };
		case types.UPDATE_BANK_ACCOUNT:
			return updateState("BankAccount");
		case types.DELETE_BANK_ACCOUNT:
			return deleteFromState("BankAccount");

		case types.GET_ALL_CREDIT_CARD:
			return { ...state, CreditCard: payload, loading: false };
		case types.GET_ONE_CREDIT_CARD:
			return { ...state, oneCreditCard: payload, loading: false };
		case types.CLEAR_ONE_CREDIT_CARD:
			return { ...state, oneCreditCard: null, loading: false };
		case types.SET_CREDIT_CARD:
			return { ...state, CreditCard: [...state.CreditCard, payload] };
		case types.UPDATE_CREDIT_CARD:
			return updateState("CreditCard");
		case types.DELETE_CREDIT_CARD:
			return deleteFromState("CreditCard");

		case types.GET_ALL_DEBIT_CATEGORY:
			return { ...state, DebitCategory: payload, loading: false };
		case types.GET_ONE_DEBIT_CATEGORY:
			return { ...state, oneDebitCategory: payload, loading: false };
		case types.CLEAR_ONE_DEBIT_CATEGORY:
			return { ...state, oneDebitCategory: null, loading: false };
		case types.SET_DEBIT_CATEGORY:
			return { ...state, DebitCategory: [...state.DebitCategory, payload] };
		case types.UPDATE_DEBIT_CATEGORY:
			return updateState("DebitCategory");
		case types.DELETE_DEBIT_CATEGORY:
			return deleteFromState("DebitCategory");

		case types.GET_ALL_CREDIT_CATEGORY:
			return { ...state, CreditCategory: payload, loading: false };
		case types.GET_ONE_CREDIT_CATEGORY:
			return { ...state, oneCreditCategory: payload, loading: false };
		case types.CLEAR_ONE_CREDIT_CATEGORY:
			return { ...state, oneCreditCategory: null, loading: false };
		case types.SET_CREDIT_CATEGORY:
			return { ...state, CreditCategory: [...state.CreditCategory, payload] };
		case types.UPDATE_CREDIT_CATEGORY:
			return updateState("CreditCategory");
		case types.DELETE_CREDIT_CATEGORY:
			return deleteFromState("CreditCategory");

		case types.GET_ALL_DEBIT_NOTE:
			return { ...state, DebitNote: payload, loading: false };
		case types.GET_ONE_DEBIT_NOTE:
			return { ...state, oneDebitNote: payload, loading: false };
		case types.CLEAR_ONE_DEBIT_NOTE:
			return { ...state, oneDebitNote: null, loading: false };
		case types.SET_DEBIT_NOTE:
			return { ...state, DebitNote: [...state.DebitNote, payload] };
		case types.UPDATE_DEBIT_NOTE:
			return updateState("DebitNote");
		case types.DELETE_DEBIT_NOTE:
			return deleteFromState("DebitNote");

		case types.GET_ALL_CREDIT_NOTE:
			return { ...state, CreditNote: payload, loading: false };
		case types.GET_ONE_CREDIT_NOTE:
			return { ...state, oneCreditNote: payload, loading: false };
		case types.CLEAR_ONE_CREDIT_NOTE:
			return { ...state, oneCreditNote: null, loading: false };
		case types.SET_CREDIT_NOTE:
			return { ...state, CreditNote: [...state.CreditNote, payload] };
		case types.UPDATE_CREDIT_NOTE:
			return updateState("CreditNote");
		case types.DELETE_CREDIT_NOTE:
			return deleteFromState("CreditNote");
		case types.GET_CR_DR_TOTAL:
			return { ...state, CrDrTotal: payload, loading: false };
		case types.GET_CURRENT_BALANCE_TOTAL:
			return { ...state, CurrentBalanceTotal: payload, loading: false };

		case types.GET_ONE_SITE_SETTING:
			return { ...state, oneSiteSetting: payload, loading: false };

		case types.GET_ONE_HOTEL_SETTING:
			return { ...state, oneHotelSetting: payload, loading: false };

		case types.GET_ALL_HOME_BANNER:
			return { ...state, HomeBanner: payload, loading: false };
		case types.GET_ONE_HOME_BANNER:
			return { ...state, oneHomeBanner: payload, loading: false };
		case types.CLEAR_ONE_HOME_BANNER:
			return { ...state, oneHomeBanner: null, loading: false };
		case types.SET_HOME_BANNER:
			return { ...state, HomeBanner: [...state.HomeBanner, payload] };
		case types.UPDATE_HOME_BANNER:
			return updateState("HomeBanner");
		case types.DELETE_HOME_BANNER:
			return deleteFromState("HomeBanner");

		case types.GET_ALL_HOME_PLACE:
			return { ...state, HomePlace: payload, loading: false };
		case types.GET_ONE_HOME_PLACE:
			return { ...state, oneHomePlace: payload, loading: false };
		case types.CLEAR_ONE_HOME_PLACE:
			return { ...state, oneHomePlace: null, loading: false };
		case types.SET_HOME_PLACE:
			return { ...state, HomePlace: [...state.HomePlace, payload] };
		case types.UPDATE_HOME_PLACE:
			return updateState("HomePlace");
		case types.DELETE_HOME_PLACE:
			return deleteFromState("HomePlace");

		case types.GET_ALL_SOU_NUMBER:
			return { ...state, PhoneNumber: payload, loading: false };
		case types.GET_ONE_SOU_NUMBER:
			return { ...state, onePhoneNumber: payload, loading: false };
		case types.CLEAR_ONE_SOU_NUMBER:
			return { ...state, onePhoneNumber: null, loading: false };
		case types.SET_SOU_NUMBER:
			return { ...state, PhoneNumber: [...state.PhoneNumber, payload] };
		case types.UPDATE_SOU_NUMBER:
			return updateState("PhoneNumber");
		case types.DELETE_SOU_NUMBER:
			return deleteFromState("PhoneNumber");

		case types.GET_ALL_BANK_ACCESS:
			return { ...state, BankAccess: payload, loading: false };
		case types.SET_BANK_ACCESS:
			return { ...state, BankAccess: [...state.BankAccess, payload] };
		case types.UPDATE_BANK_ACCESS:
			return updateState("BankAccess");

		case types.GET_DASHBOARD_DATA:
			return { ...state, DashboardData: payload, loading: false };
		case types.GET_DASHBOARD_OTHER_DATA:
			return { ...state, DashboardOtherData: payload, loading: false };

		case types.GET_ACCESS_KEYS:
			return { ...state, AccessKeys: payload, loading: false };

		case types.GET_ALL_BANK_TRANSFER:
			return { ...state, BankTransfer: payload, loading: false };
		case types.SET_BANK_TRANSFER:
			return { ...state, BankTransfer: [...state.BankTransfer, payload] };

		case types.GET_ALL_NUMBER_ACCESS:
			return { ...state, NumberAccess: payload, loading: false };
		case types.SET_NUMBER_ACCESS:
			return { ...state, NumberAccess: [...state.NumberAccess, payload] };
		case types.UPDATE_NUMBER_ACCESS:
			return updateState("NumberAccess");

		case types.GET_ALL_QUOTATION:
			return { ...state, Quotation: payload, loading: false };
		case types.GET_ONE_QUOTATION:
			return { ...state, oneQuotation: payload, loading: false };
		case types.CLEAR_ONE_QUOTATION:
			return { ...state, oneQuotation: null, loading: false };
		case types.SET_QUOTATION:
			return { ...state, Quotation: [...state.Quotation, payload] };
		case types.UPDATE_QUOTATION:
			return updateState("Quotation");
		case types.DELETE_QUOTATION:
			return deleteFromState("Quotation");

		case types.GET_ALL_VISITOR:
			return { ...state, Visitor: payload, loading: false };
		case types.SET_ALL_VISITOR:
			return { ...state, Visitor: [...state.Visitor, payload] };
		case types.UPDATE_VISITOR:
			return updateState("Visitor");
		case types.DELETE_VISITOR:
			return deleteFromState("Visitor");

		case types.GET_ALL_COUNTRIES:
			return { ...state, Countries: payload, loading: false };
		case types.GET_ALL_STATES:
			return { ...state, States: payload, loading: false };
		case types.GET_TEAM_BANK_REPORT:
			return { ...state, TeamBankReport: payload, loading: false };
		case types.GET_TEAM_SALES_REPORT:
			return { ...state, StaffSalesReport: payload, loading: false };
		case types.GET_TEAM_SALES_DATA:
			return { ...state, StaffSalesData: payload, loading: false };

		case types.GET_ALL_ENQUIRY:
			return { ...state, Enquiry: payload, loading: false };
		case types.GET_ONE_ENQUIRY:
			return { ...state, oneEnquiry: payload, loading: false };
		case types.CLEAR_ONE_ENQUIRY:
			return { ...state, oneEnquiry: null, loading: false };
		case types.SET_ENQUIRY:
			return { ...state, Enquiry: [...state.Enquiry, payload] };
		case types.UPDATE_ENQUIRY:
			return updateState("Enquiry");
		case types.DELETE_ENQUIRY:
			return deleteFromState("Enquiry");

		case types.GET_ALL_PACKAGE_IMAGE:
			return { ...state, PackageImage: payload, loading: false };
		case types.SET_PACKAGE_IMAGE:
			return { ...state, PackageImage: [...state.PackageImage, payload] };
		case types.DELETE_PACKAGE_IMAGE:
			return deleteFromState("PackageImage");

		case types.GET_ALL_PACKAGE_VIDEO:
			return { ...state, PackageVideo: payload, loading: false };
		case types.SET_PACKAGE_VIDEO:
			return { ...state, PackageVideo: [...state.PackageVideo, payload] };
		case types.DELETE_PACKAGE_VIDEO:
			return deleteFromState("PackageVideo");

		case types.GET_ALL_PACKAGE_REELS:
			return { ...state, PackageReels: payload, loading: false };
		case types.SET_PACKAGE_REELS:
			return { ...state, PackageReels: [...state.PackageReels, payload] };
		case types.DELETE_PACKAGE_REELS:
			return deleteFromState("PackageReels");

		case types.GET_PAYMENT_HISTORY:
			return { ...state, PaymentHistory: payload, loading: false };

		case types.GET_DAILY_LEDGER:
			return { ...state, DailyLedger: payload, loading: false };

		case types.GET_TEAM_SEALERY_REPORT:
			return { ...state, TeamSalaryReport: payload, loading: false };

		case types.GET_PLACE_BOOKING_OFF_SETTING:
			return { ...state, PlaceBookingOffSetting: payload, loading: false };
		case types.SET_PLACE_BOOKING_OFF_SETTING:
			return {
				...state,
				PlaceBookingOffSetting: [...state.PlaceBookingOffSetting, payload],
			};
		case types.DELETE_PLACE_BOOKING_OFF_SETTING:
			return deleteFromState("PlaceBookingOffSetting");

		case types.GET_ONE_HOME_NOTE:
			return { ...state, homeNote: payload, loading: false };

		case types.GET_ALL_SOU_PLACE_KEY:
			return { ...state, PlaceKeys: payload, loading: false };

		case types.GET_ALL_FAQ:
			return { ...state, Faq: payload, loading: false };
		case types.GET_ONE_FAQ:
			return { ...state, oneFaq: payload, loading: false };
		case types.CLEAR_ONE_FAQ:
			return { ...state, oneFaq: null, loading: false };
		case types.SET_FAQ:
			return { ...state, Faq: [...state.Faq, payload] };
		case types.UPDATE_FAQ:
			return updateState("Faq");
		case types.DELETE_FAQ:
			return deleteFromState("Faq");
		case types.GET_WARNING_MESSAGE:
			return { ...state, warningMessage: payload, loading: false };

		case types.GET_AVAILABLE_TICKETS:
			return { ...state, AvailableTicket: payload, loading: false };
		case types.UPDATE_AVAILABLE_TICKETS:
			return updateState("AvailableTicket");

		case types.GET_NOTIFICATION_COUNT:
			return { ...state, notificationCount: payload, loading: false };
		case types.GET_ALL_NOTIFICATION:
			return { ...state, AllNotification: payload, loading: false };

		case types.GET_ALL_HOTEL:
			return { ...state, AllHotel: payload, loading: false };

		case types.GET_ALL_TESTIMONIAL:
			return { ...state, Testimonial: payload, loading: false };
		case types.GET_ONE_TESTIMONIAL:
			return { ...state, oneTestimonial: payload, loading: false };
		case types.CLEAR_ONE_TESTIMONIAL:
			return { ...state, oneTestimonial: null, loading: false };
		case types.SET_TESTIMONIAL:
			return { ...state, Testimonial: [...state.Testimonial, payload] };
		case types.UPDATE_TESTIMONIAL:
			return updateState("Testimonial");
		case types.DELETE_TESTIMONIAL:
			return deleteFromState("Testimonial");

		case types.GET_SALES_REPORT:
			return { ...state, SalesReport: payload, loading: false };
		case types.GET_SALES_REPORT_EXPORT:
			return { ...state, SalesReportExport: payload, loading: false };
		case types.GET_SALES_REPORT_TOTAL:
			return { ...state, SalesReportTotal: payload, loading: false };

		case types.GET_PURCHASE_REPORT:
			return { ...state, PurchaseReport: payload, loading: false };
		case types.GET_PURCHASE_REPORT_EXPORT:
			return { ...state, PurchaseReportExport: payload, loading: false };
		case types.GET_PURCHASE_REPORT_TOTAL:
			return { ...state, PurchaseReportTotal: payload, loading: false };

		case types.GET_COMMISSION_REPORT:
			return { ...state, CommissionReport: payload, loading: false };
		case types.GET_COMMISSION_REPORT_EXPORT:
			return { ...state, CommissionReportExport: payload, loading: false };
		case types.GET_COMMISSION_REPORT_TOTAL:
			return { ...state, CommissionReportTotal: payload, loading: false };

		case types.GET_CANCEL_REPORT:
			return { ...state, CancelReport: payload, loading: false };
		case types.GET_CANCEL_REPORT_EXPORT:
			return { ...state, CancelReportExport: payload, loading: false };
		case types.GET_CANCEL_REPORT_TOTAL:
			return { ...state, CancelReportTotal: payload, loading: false };

		case types.GET_ATTRACTION_REPORT:
			return { ...state, AttractionReport: payload, loading: false };
		case types.GET_ATTRACTION_REPORT_EXPORT:
			return { ...state, AttractionReportExport: payload, loading: false };
		case types.GET_ATTRACTION_REPORT_TOTAL:
			return { ...state, AttractionReportTotal: payload, loading: false };
		case types.GET_GST_REPORT:
			return { ...state, GstReport: payload, loading: false };
		case types.GET_GST_REPORT_EXPORT:
			return { ...state, GstReportExport: payload, loading: false };
		case types.GET_GST_REPORT_TOTAL:
			return { ...state, GstReportTotal: payload, loading: false };
		case types.GET_BOOKING_FOR_REVIEW:
			return { ...state, BookingForReview: payload, loading: false };

		// Blog Category cases
		case types.GET_ALL_BLOG_CATEGORY:
			return { ...state, BlogCategory: payload, loading: false };
		case types.GET_ONE_BLOG_CATEGORY:
			return { ...state, oneBlogCategory: payload, loading: false };
		case types.CLEAR_ONE_BLOG_CATEGORY:
			return { ...state, oneBlogCategory: null, loading: false };
		case types.SET_BLOG_CATEGORY:
			return { ...state, BlogCategory: [...state.BlogCategory, payload] };
		case types.UPDATE_BLOG_CATEGORY:
			return updateState("BlogCategory");
		case types.DELETE_BLOG_CATEGORY:
			return deleteFromState("BlogCategory");

		// Blog cases
		case types.GET_ALL_BLOG:
			return { ...state, Blog: payload, loading: false };
		case types.GET_ONE_BLOG:
			return { ...state, oneBlog: payload, loading: false };
		case types.CLEAR_ONE_BLOG:
			return { ...state, oneBlog: null, loading: false };
		case types.SET_BLOG:
			return { ...state, Blog: [...state.Blog, payload] };
		case types.UPDATE_BLOG:
			return updateState("Blog");
		case types.DELETE_BLOG:
			return deleteFromState("Blog");

		// Blog Comment cases
		case types.GET_ALL_BLOG_COMMENT:
			return { ...state, BlogComment: payload, loading: false };
		case types.SET_BLOG_COMMENT:
			return { ...state, BlogComment: [...state.BlogComment, payload] };
		case types.UPDATE_BLOG_COMMENT:
			return updateState("BlogComment");
		case types.DELETE_BLOG_COMMENT:
			return deleteFromState("BlogComment");

		case types.GET_TEAM_BANK_REPORT_DATA:
			return { ...state, StaffBankDetailData: payload, loading: false };

		case types.GET_ALL_DAILY_SETTLEMENTS:
			return { ...state, DailySettlement: payload, loading: false };
		case types.GET_ONE_DAILY_SETTLEMENT:
			return { ...state, oneDailySettlement: payload, loading: false };
		case types.CLEAR_ONE_DAILY_SETTLEMENT:
			return { ...state, oneDailySettlement: null, loading: false };

		case types.GET_ALL_TALLY_MAIN_GROUP:
			return { ...state, AccountMainGroup: payload, loading: false };
		case types.SET_TALLY_MAIN_GROUP:
			return { ...state, AccountMainGroup: [...state.AccountMainGroup, payload] };
		case types.UPDATE_TALLY_MAIN_GROUP:
			return updateState("AccountMainGroup");
		case types.DELETE_TALLY_MAIN_GROUP:
			return deleteFromState("AccountMainGroup");

		case types.GET_ALL_TALLY_SUB_GROUP:
			return { ...state, AccountSubGroup: payload, loading: false };
		case types.SET_TALLY_SUB_GROUP:
			return { ...state, AccountSubGroup: [...state.AccountSubGroup, payload] };
		case types.UPDATE_TALLY_SUB_GROUP:
			return updateState("AccountSubGroup");
		case types.DELETE_TALLY_SUB_GROUP:
			return deleteFromState("AccountSubGroup");

		case types.GET_ALL_TALLY_LEDGER:
			return { ...state, AccountLedger: payload, loading: false };
		case types.SET_TALLY_LEDGER:
			return { ...state, AccountLedger: [...state.AccountLedger, payload] };
		case types.UPDATE_TALLY_LEDGER:
			return updateState("AccountLedger");
		case types.DELETE_TALLY_LEDGER:
			return deleteFromState("AccountLedger");

		case types.GET_ALL_SALES:
			return { ...state, Sales: payload, loading: false };
		case types.GET_ALL_PURCHASE:
			return { ...state, Purchase: payload, loading: false };

		case types.GET_TALLY_BALANCE_SHEET:
			return { ...state, TallyBalanceSheet: payload, loading: false };
		case types.GET_TALLY_PROFIT_LOSS:
			return { ...state, TallyProfitLoss: payload, loading: false };
		
		case types.GET_AUTO_ACCOUNT_ENTRY_SETTING:
			return { ...state, AutoAccountEntrySetting: payload, loading: false };
		
		case types.UPDATE_AUTO_ACCOUNT_ENTRY_SETTING:
			const index = state.AutoAccountEntrySetting.findIndex(item => item.entryType === payload.entryType);
			let updatedSettings;
			if (index !== -1) {
				updatedSettings = state.AutoAccountEntrySetting.map((item, i) => i === index ? payload : item);
			} else {
				updatedSettings = [...state.AutoAccountEntrySetting, payload];
			}
			return {
				...state,
				AutoAccountEntrySetting: updatedSettings,
			};

		case types.GET_ALL_OPTIONAL_ATTRACTION:
			return { ...state, OptionalAttraction: payload, loading: false };
		case types.SET_OPTIONAL_ATTRACTION:
			return { ...state, OptionalAttraction: [...state.OptionalAttraction, payload] };
		case types.UPDATE_OPTIONAL_ATTRACTION:
			return updateState("OptionalAttraction");
		case types.GET_ONE_OPTIONAL_ATTRACTION:
			return { ...state, oneOptionalAttraction: payload };
		case types.CLEAR_ONE_OPTIONAL_ATTRACTION:
			return { ...state, oneOptionalAttraction: null };
		case types.DELETE_OPTIONAL_ATTRACTION:
			return deleteFromState("OptionalAttraction");

		case types.GET_ALL_SITEMAP:
			return { ...state, Sitemap: payload, loading: false };
		case types.GET_ONE_SITEMAP:
			return { ...state, oneSitemap: payload, loading: false };
		case types.CLEAR_ONE_SITEMAP:
			return { ...state, oneSitemap: null, loading: false };
		case types.SET_SITEMAP:
			return { ...state, Sitemap: [...state.Sitemap, payload] };
		case types.UPDATE_SITEMAP:
			return updateState("Sitemap");
		case types.DELETE_SITEMAP:
			return deleteFromState("Sitemap");

		default:
			return state;
	}
};

export default userReducers;
